import styles from './../../index.module.scss'
import iconLinePurple from '@/assets/image/solution/custodial/line_purple.png';
import iconLineGray from '@/assets/image/solution/custodial/line_gray.png';
import flowImg2 from '@/assets/image/solution/custodial/flow_img2.png';
import iconLinePurpleMobile from '@/assets/image/solution/custodial/line_purple_mobile.png';
import iconLineGrayMobile from '@/assets/image/solution/custodial/line_gray_mobile.png';
import flowImg2Mobile from '@/assets/image/solution/custodial/flow_img2_mobile.png';
import { useMediaQuery } from 'react-responsive';

const Card3 = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className={`${styles.card2} w-1340`}>
      {
        isMobile?(
          <>
            <div className={`${styles.cardHead}`}>
              <div className={`${styles.headTitle}`}>Non-Custodial Yield Generation</div>
              <div className={`${styles.headExtra} flex align-items`}>
                <div className={`${styles.headExtra} flex align-items`}>
                  <img src={iconLinePurpleMobile} className={styles.line} />
                  <div className={`${styles.headExtraText}`}>Vishwa</div>
                </div>
                <div className={`${styles.headExtra} flex align-items`}>
                  <img src={iconLineGrayMobile} className={styles.line} />
                  <div className={`${styles.headExtraText}`}>Users</div>
                </div>
              </div>
            </div>
            <div className={`${styles.cardContent}`}>
              <img src={flowImg2Mobile} data-src={flowImg2Mobile} loading="lazy" />
            </div>
          </>
        ) : (
          <>
            <div className={`${styles.cardHead} flex align-items flex-just`}>
              <div className={`${styles.headTitle}`}>Non-Custodial Yield Generation</div>
              <div className={`${styles.headExtra}`}>
                <div className={`${styles.headExtra} flex align-items`}>
                  <img src={iconLinePurple} className={styles.line} />
                  <div className={`${styles.headExtraText}`}>Vishwa</div>
                </div>
                <div className={`${styles.headExtra} flex align-items`}>
                  <img src={iconLineGray} className={styles.line} />
                  <div className={`${styles.headExtraText}`}>Users</div>
                </div>
              </div>
            </div>
            <div className={`${styles.cardContent}`}>
              <img src={flowImg2} data-src={flowImg2} loading="lazy" />
            </div>
          </>
        )
      }

    </div>
  )
}

export default Card3